<template>
  <div class="card_flex">
    <div class="filter">
      <div class="input_wrap">
        <fg-input
            v-model="filter.searchword"
            type="text"
            class=""
            :clearable="true"
            :label="translate('group.search')"
            placeholder="name group"
            @input="pre_search"
        />
      </div>

      <div class="input_wrap select">
          <label> {{ translate('user.client') }} </label>
          <tree-select
              :options="clients_list"
              v-model="filter.client_id"
              :placeholder="translate('user.client')"
              :searchable="true"
              :multiple="false"
              :hide-selected="true"
              :clearable="true"
          />
      </div>

      <button
        class="btn btn-success"
        @click="pre_search"
      >
        {{ translate('search') }}
      </button>
    </div>
    <div class="group_list device_groups">

      <v-tree v-show="!loading" style="margin-top: 10px; margin-left: 30px" ref='tree1' @drag-node-end="drag" :canDeleteRoot="true" :data='groupTree' :draggable='true' :tpl='tpl' />
      <div v-show="loading">
        <scale-loader />
      </div>

    </div>
  </div>
</template>

<script>
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'DeviceGroupTree',
  components: {
  },
  props: {
    parent_filter: {
      type: [Array, Object],
      default: () => {}
    }
  },
  data () {
    return {
      new_group: {},
      filter:{
        searchword: "",
        client_id: null,
        group_id: null
      },
      search_group: [],
      cur_group: null,
      empty: false,
      loading: false
    }
  },
  computed: {
    clients_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: client.id}
      })
    },
    groups () {
      return this.$store.getters.getDeviceGroups
    },
    groupTree () {
        if (this.empty){
            return  [{
                expanded: true,
                id: -1,
                label: 'all group',
                name: 'all group',
                children: []
            }]

        }else{
            return  [{
                expanded: true,
                id: -1,
                label: 'all group',
                name: 'all group',
                children: this.$store.getters.getDeviceGroupsTree
            }]
        }
    },
  },

  watch: {
    // parent_filter(){
    //   console.log(this.parent_filter)
    //   this.filter = this.parent_filter
    // },
    filter: {
      deep: true,
      handler() {
        this.$emit("filter", this.filter)
      }
    },
    'filter.client_id':{
      handler(){
        this.pre_search()
      }
    },
    groups(){
      if (this.cur_group && this.cur_group.id) {
        this.choice(this.$store.getters.getDeviceGroupById(this.cur_group.id))
      }
    },
    groupTree () {
      if(this.new_group.id !== undefined) {
        this.$refs.tree1.searchNodes((node) => {
          if (node.id === this.new_group.id) {
            this.choice(node)
            node.searched = true
            this.new_group = {}
          }
        })
      }
    }
  },

  activated() {
    let interval = setInterval(() => {
      if (this.groupTree[0].children.length > 0){
        this.filter = this.parent_filter
        this.pre_search()
        clearInterval(interval)
      }
    },10)
  },

  methods: {
    pre_search(){
      this.loading = true
      this.empty = false
      setTimeout(this.search, 100)
    },
    search() {
      let searched = []

      this.$refs.tree1.searchNodes((node) => {
        console.log(this.filter)
        let name = node.name.toLowerCase()

        const matchSearchword = !this.filter.searchword ||
            name.indexOf(this.filter.searchword.toLowerCase()) !== -1

        const matchClient = !this.filter.client_id ||
            node.client_id === Number(this.filter.client_id)

        for (let elem of searched) {
          if (elem.id === node.parent) {
            searched.push(elem)
            return elem
          }
        }

        if (matchSearchword && matchClient) {
          searched.push(node)
          return node
        }
      })

      if (!searched.length) {
        this.empty = true
        this.clear()
        this.global_notify('danger', this.translate('search_nothing'))
      }

      this.loading = false
    },
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      let cross = (parent !== null && this.$store.getters.getPermissions.editDeviceGroups === true) ? <span class="mdi mdi-close-box red" onClick={() => this.delete_confirm(node, parent, index)} title="delete"/> : ''

      let add = this.$store.getters.getPermissions.editDeviceGroups === true ?
          <button
            className="treebtn1"
            onClick={() => this.addDeviceGroup(node)}
          >
            +
          </button>
          : ''


      return <span class="tree_element">

        {add}

        <span class={titleClass} domPropsInnerHTML={node.name} onClick={() => {
          if(parent == null) {
            this.clear()
            return false
          }
          this.choice(node)
        }}>

        </span>
        {cross}
      </span>
    },
    drag (...args) {
      let {dragNode: dragNode, targetNode: target} = args[0]
      this.$http.v1.updateParentGroup({'id': dragNode.id, 'name': dragNode.name, 'parent': target.id}, () => {
        this.global_notify('info', this.translate('group.updated'))
          this.$store.dispatch('deviceGroupUpdate')
      }, (bad_answer) => {
          this.bad_answer_handler(bad_answer)
          this.$store.dispatch('deviceGroupUpdate')
      })
    },
    choice (group) {
      if (group.id) this.$emit('filter', {group_id: group.id})
      this.cur_group = group
      this.$emit('choice', group)
    },
    clear(){
      this.choice({})
    },

    delete_confirm (node) {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: `${this.translate('group.del')} <b>${node.name}</b>?`
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          },
          confirm: () => {
            this.deleteDeviceGroup(node)
            this.$modal.hide('dynamic-modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'dynamic-modal'})

    },

    deleteDeviceGroup (node) {
      this.$http.v1.deleteDeviceGroup({'id': node.id}, () => {
        this.global_notify('info', this.translate('group.deleted'))
        if (this.cur_group.id === node.id){
          this.clear()
        }
        this.$store.dispatch('deviceGroupUpdate')
      }, (bad_answer) => {
        this.bad_answer_handler(bad_answer)
        this.$store.dispatch('deviceGroupUpdate')
      })
    },
    addDeviceGroup (node) {
      this.$http.v1.createDeviceGroup({'name': "!new group", 'parent': node.id }, (resp) => {
        this.global_notify('info', this.translate('group.added'))
        this.$store.dispatch('deviceGroupUpdate');
        this.new_group = resp.data
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.card_flex {
  overflow: hidden;
  padding: 10px;
  .filter {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 10px;
    .input_wrap{
      position: relative;
      width: 40%;
      .form-group{
        margin-bottom: 0;
      }
      .clear{
        position: absolute;
        right: 5px;
        bottom: 0;
        height: 40px;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #66615b;
        font-weight: bold;
        cursor: pointer;
        &:hover{
          color: #e53935;
        }
      }
    }

    .btn{
      width: 15%;
      padding: 7px;
      height: 40px;
    }
  }
  .group_list {
    overflow: auto;
    width: 100%;
    flex: 12;
    border: 1px solid #DCDCDC;
  }
}

@media (max-width: 768px) {
  .card_flex {
    padding: 10px 0;
    .filter {
      .form-group{
        width: 70%;
        margin-right: 10px;
      }
      .btn{
        width: 30%;
      }
    }
    .group_list {
      overflow: auto;
      width: 100%;
      flex: 12;
      border: 1px solid #DCDCDC;
    }
  }
}
</style>
